import React, { type ComponentType } from 'react';

import { excludeKeys } from 'src/app/utils/excludeKeys';
import { useDraft } from 'src/app/views/hooks/useDraft';
import type { DispatchDraftResponse } from 'src/types/draft';

interface Props {
  handleDispatchDraft?: (
    isComplete?: boolean,
    rejectOnError?: boolean,
  ) => DispatchDraftResponse;
}

export const withDispatchDraft =
  (WrappedComponent: ComponentType<any>) => (props: any & Props) => {
    const { saveDraft } = useDraft();

    const allProps = {
      ...excludeKeys(props, 'formData', 'advertiserId', 'draftId'),
      handleDispatchDraft: saveDraft,
    };

    return <WrappedComponent {...allProps} />;
  };
